export const buildServiceUrl = (urlPrefix: string, urlSuffix?: string) => {
    return process.env.REACT_APP_HTTP_PREFIX + urlPrefix + process.env.REACT_APP_BASE_DOMAIN + (urlSuffix ?? '');
};

export function buildOnlineServiceUrl(servicePath: string) {
    return process.env.NODE_ENV === 'development'
        ? '/proxy' + servicePath
        : buildServiceUrl(
              process.env.REACT_APP_RISK_PROXY_SERVICE_PREFIX,
              process.env.REACT_APP_RISK_PROXY_SERVICE_SUFFIX,
          ) + servicePath;
}

const getServiceUrls = () => {
    const ticketServiceUrl = buildOnlineServiceUrl('/ecs');
    const monitoringServiceUrl = buildOnlineServiceUrl('/rms');
    const reportingServiceUrl =
        buildServiceUrl(
            process.env.REACT_APP_REPORTING_SERVICE_URL_PREFIX,
            process.env.REACT_APP_REPORTING_SERVICE_URL_SUFFIX,
        ) + '/api';
    const dataPublisherUrl =
        process.env.REACT_APP_SOCKET_PREFIX +
        process.env.REACT_APP_MT_SOCKET_URL_PREFIX +
        process.env.REACT_APP_BASE_DOMAIN;
    const onlineFeedServiceUrl = buildOnlineServiceUrl('/online/feed');
    const onlineContentServiceUrl = buildOnlineServiceUrl('/online/content');
    const onlineReportServiceUrl = buildOnlineServiceUrl('/online/report');
    const onlineBackOfficeServiceUrl = buildOnlineServiceUrl('/online/backoffice');
    const bonusServiceUrl = buildOnlineServiceUrl('/online/bonus');

    return {
        TICKET_API_ENDPOINT: ticketServiceUrl,
        REPORT_API_ENDPOINT: reportingServiceUrl,
        MONITORING_API_ENDPOINT: monitoringServiceUrl,
        socketUrl: dataPublisherUrl,
        ONLINE_CONTENT_SERVICE_API_ENDPOINT: onlineContentServiceUrl,
        ONLINE_REPORT_SERVICE_API_ENDPOINT: onlineReportServiceUrl,
        ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT: onlineBackOfficeServiceUrl,
        ONLINE_FEED_SERVICE_API_ENDPOINT: onlineFeedServiceUrl,
        BONUS_SERVICE_API_ENDPOINT: bonusServiceUrl,
    };
};
export const {
    TICKET_API_ENDPOINT,
    REPORT_API_ENDPOINT,
    MONITORING_API_ENDPOINT,
    socketUrl,
    ONLINE_CONTENT_SERVICE_API_ENDPOINT,
    ONLINE_REPORT_SERVICE_API_ENDPOINT,
    ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT,
    ONLINE_FEED_SERVICE_API_ENDPOINT,
    BONUS_SERVICE_API_ENDPOINT,
} = getServiceUrls();

export const MBN_TOURNAMENTS = `${TICKET_API_ENDPOINT}/tournament-mbn-templates`;

export const GET_MARKETS = `${TICKET_API_ENDPOINT}/market`;
export const GET_MARKET_GROUPS = `${TICKET_API_ENDPOINT}/market/groups`;
export const GET_MARKET_COLUMN_TYPES = `${TICKET_API_ENDPOINT}/market/column-types`;
export const GET_MARKET_OUTCOMES = `${TICKET_API_ENDPOINT}/outcomes`;
export const CATEGORIES = `${TICKET_API_ENDPOINT}/categories?sportId=`;
export const TOURNAMENTS = `${TICKET_API_ENDPOINT}/tournaments?categoryId=`;
export const MBN_MARKET_TEMPLATE = `${TICKET_API_ENDPOINT}/market-mbn-templates`;
export const EVENT_STATUSES = `${MONITORING_API_ENDPOINT}/data/event/statuses`;

export const EVENT_VIEWER = `${MONITORING_API_ENDPOINT}/event-viewer/template`;
export const MARKET_GROUP_LABELS = `${MONITORING_API_ENDPOINT}/labels`;
